import Service from '@/helpers/adminService'

export default {

    index(params) {
        return Service().get('admin/registrations', {params});
    },
    updateStatus(id, params) {
        return Service().post('admin/registrations/'+id+'/status', params);
    },
    delete(id) {
        return Service().delete('admin/registrations/'+id);
    },
}
